var annotate = require('annotate');
var is = require('annois');


module.exports = function() {
    return annotate('nan', 'Generates NaN')
        .on(function() {
            return NaN;
        }).satisfies(is.nan);
};



//////////////////
// WEBPACK FOOTER
// ./~/annogenerate/lib/nan.js
// module id = 778
// module chunks = 0